import React, { type ComponentType, Component } from 'react';
import noop from 'lodash/noop';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import { ELID_ISSUE_HEADER } from '@atlassian/jira-issue-view-common-constants/src/index.tsx';
import { emptyConfiguration } from '@atlassian/jira-issue-view-configurations/src/index.tsx';
import { IssueBoundary } from '@atlassian/jira-issue-view/src/async.tsx';
import type { MetricsCallbacks } from '@atlassian/jira-issue-view/src/common/metrics/context/index.tsx';
import type { IssueAppProps } from '@atlassian/jira-issue-view/src/views/issue-details/issue-app.tsx';
import { SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { StickyElementAligner } from './sticky-element-aligner/index.tsx';
import type { AppProps } from './types.tsx';
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyIssueApp: ComponentType<IssueAppProps> = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-issue-app" */ '@atlassian/jira-issue-view/src/views/issue-details/issue-app'
		),
	{ ssr: false },
);
// eslint-disable-next-line jira/react/no-class-components
export class GlobalIssueNavigatorIssueApp extends Component<AppProps> {
	static defaultProps = {
		isLoadedWithPage: false,
	};

	render() {
		const metricsCallbacks: MetricsCallbacks = {
			onReadyForUser: () => this.props.onIssueAppReady(),
		};
		return (
			<StickyElementAligner
				elementToAlignSelector={`#${ELID_ISSUE_HEADER}`}
				alignWithSelector="#issue-content .issue-header"
			>
				<IssueBoundary packageName="global-issue-navigator">
					<LazyIssueApp
						{...emptyConfiguration()}
						analyticsSource="global-issue-navigator-issue"
						dispatchExternalActionRef={this.props.onDispatchExternalActionRef}
						isLoadedWithPage={this.props.isLoadedWithPage}
						onIssueDeleteSuccess={this.props.onIssueDeleteSuccess}
						issueKey={this.props.issueKey}
						metrics={metricsCallbacks}
						onClose={noop}
						shouldSetInitialFocus={false}
						shouldShowProjectLevelBreadcrumb
						shouldShowRootProjectsBreadcrumb
					/>
				</IssueBoundary>
			</StickyElementAligner>
		);
	}
}
export default AnalyticsSource('globalIssueNavigatorIssue', SCREEN)(GlobalIssueNavigatorIssueApp);
